import { useEffect } from "react";
import TagManager from "react-gtm-module";

import settings from "../configs/config_settings.json";

export const GTMProvider = ({ children }) => {
	useEffect(() => {
		if (settings.organization.googleAnalyticsTagManager) {
			const tagManagerArgs = {
				gtmId: settings.organization.googleAnalyticsTagManager,
			};

			TagManager.initialize(tagManagerArgs);
		}
	}, []);

	return children;
};
